import React from 'react'
import { I18n } from 'react-redux-i18n'

import InputControls from 'components/common/InputControls'

function SwitchControl(props) {
  const { label, value = false, onChange } = props

  let text = label
  if (!text) text = I18n.t(value ? 'dashboard_enabled' : 'dashboard_disabled')

  return (
    <InputControls
      label={text}
      value={value}
      onChange={onChange}
    />
  )
}

export default SwitchControl
